import { render, staticRenderFns } from "./PersonalHealthInformation.vue?vue&type=template&id=728c8901&scoped=true"
import script from "./PersonalHealthInformation.vue?vue&type=script&lang=js"
export * from "./PersonalHealthInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c8901",
  null
  
)

export default component.exports